import { render } from "./HotRanking.vue?vue&type=template&id=aee896a6&scoped=true"
import script from "./HotRanking.vue?vue&type=script&lang=js"
export * from "./HotRanking.vue?vue&type=script&lang=js"

import "./HotRanking.vue?vue&type=style&index=0&id=aee896a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aee896a6"]])

export default __exports__